import { MODES, THEMES } from '../theme';
import './StyleSwitcher.css';

const AUTO_SWATCH = `conic-gradient(${THEMES.dawn.swatch[0]} 0 33%, ${THEMES.day.swatch[0]} 0 66%, ${THEMES.night.swatch[0]} 0)`;

// Review tool for comparing the art directions; not part of the site.
export default function StyleSwitcher({ mode, phase, onChange }) {
  return (
    <div className="switcher" role="radiogroup" aria-label="Design direction">
      <span className="switcher__label">Style</span>
      {MODES.map((m) => {
        const auto = m === 'auto';
        const t = THEMES[m];
        return (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={mode === m}
            className={`switcher__btn${mode === m ? ' is-active' : ''}`}
            onClick={() => onChange(m)}
            title={auto ? 'Follows the local time of day' : undefined}
          >
            <span
              className="switcher__swatch"
              style={{ background: auto ? AUTO_SWATCH : `linear-gradient(135deg, ${t.swatch[0]} 50%, ${t.swatch[1]} 50%)` }}
            />
            {auto ? (
              <>
                Auto <span className="switcher__hint">· {THEMES[phase].label}</span>
              </>
            ) : (
              t.label
            )}
          </button>
        );
      })}
    </div>
  );
}
